<template>
  <page-with-sidebar>
    <div slot="sidebar">
      <user-account-sidebar ref="sidebarMenu" :menu-items="userMenu" @selected="handleMenuItemSelect"/>
    </div>
    <page-layout>
      <section slot="header">
        <transition name="fade" mode="out-in">
          <header-user-account v-if="Object.keys(userInfo).length"
                               :key="'header'"
                               :header-info="userInfo"/>
          <div v-else
               :key="'headerPlaceholder'"
               class="header-placeholder"></div>
        </transition>
      </section>
      <transition name="fade" mode="out-in">
        <section class="page-content" :key="componentKey">
          <div class="main-content">
            <component :user-info="userInfo" :is="mainComponent" :resources-data="{}" @refresh="handleRefresh"/> <!-- resources-data="{}" je privremeno, to ovde verovatno necemo da koristimo -->
          </div>
        </section>
      </transition>
    </page-layout>
  </page-with-sidebar>
</template>

<script>
import PageWithSidebar from '@/components/common/main-layout/page-with-sidebar'
import PageLayout from '@/components/common/main-layout/page-layout'
import UserAccountSidebar from '@/components/common/navigation/user-account-sidebar'
import UserAccountManagement from '@/components/userAccount/user-account-management'
import HeaderUserAccount from '@/components/userAccount/headers/header-user-account'
import UserSecurityCode from '@/components/userAccount/user-security-code'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import UserDeactivateSecurityCode from '@/components/userAccount/user-deactivate-security-code'
import UserPaymentCards from '@/components/userAccount/user-payment-cards'
import EmailAddressChange from '@/components/userAccount/email-address-change'
import UserPasswordChange from '@/components/userAccount/user-password-change'
import PhoneChange from '@/components/userAccount/phone-change'
import { getHashPath, clearHash } from '@/utils/hashHistoryHandler'
import { lsGet, lsRemove } from '@/utils/localStorageController'
import { addDataLayerEvent } from '@/services/dataLayer'
import { addUserIdDataLayerEvent } from '../utils/addUserIdDataLayerEvent'

export default {
  name: 'page-user-account',
  data () {
    return {
      selectedService: '',
      componentKey: '',
      mainComponent: null,
      userInfo: {},
      userAccountMenu: [
        {
          name: 'accountManagement',
          title: this.$t('userAccount.sidebarMenu.accountManagement')
        },
        {
          name: 'userData',
          title: this.$t('userAccount.sidebarMenu.userData'),
          submenu: [
            {
              name: 'passwordChange',
              title: this.$t('userAccount.sidebarMenu.passwordChange')
            },
            {
              name: 'emailChange',
              title: this.$t('userAccount.sidebarMenu.emailChange')
            },
            {
              name: 'phoneChange',
              title: this.$t('userAccount.sidebarMenu.phoneChange')
            }
          ]
        },
        {
          name: 'paymentCards',
          title: this.$t('userAccount.sidebarMenu.paymentCards')
        },
        {
          name: 'securityCode',
          title: this.$t('userAccount.sidebarMenu.securityCode')
        }
      ],
      securityCodeSubmenu: [
        {
          name: 'changeSecurityCode',
          title: this.$t('userAccount.sidebarMenu.changeSecurityCode')
        },
        {
          name: 'deactivateSecurityCode',
          title: this.$t('userAccount.sidebarMenu.deactivateSecurityCode')
        }
      ]
    }
  },
  components: {
    UserPasswordChange,
    UserDeactivateSecurityCode,
    UserSecurityCode,
    HeaderUserAccount,
    UserAccountManagement,
    UserAccountSidebar,
    PageLayout,
    PageWithSidebar,
    UserPaymentCards,
    EmailAddressChange,
    PhoneChange
  },
  mixins: [errorMessageHandler],
  computed: {
    userMenu () {
      if (this.userInfo.securityCodeActive) {
        return this.userAccountMenu.map(menuItem => {
          if (menuItem.name === 'securityCode') {
            return {
              ...menuItem,
              submenu: [...this.securityCodeSubmenu]
            }
          }
          return menuItem
        })
      }
      return Object.freeze(this.userAccountMenu)
    }
  },
  methods: {
    handleMenuItemSelect (payload) {
      const { name } = payload
      // rerender components
      this.componentKey = new Date().getTime()

      this.selectedService = name

      this.mainComponent = this.getMainComponent(name)
    },
    getMainComponent (name) {
      if (name === 'accountManagement') {
        return 'user-account-management'
      } else if (name === 'passwordChange') {
        return 'user-password-change'
      } else if (name === 'securityCode') {
        return 'user-security-code'
      } else if (name === 'deactivateSecurityCode') {
        return 'user-deactivate-security-code'
      } else if (name === 'changeSecurityCode') {
        return 'user-security-code'
      } else if (name === 'paymentCards') {
        return 'user-payment-cards'
      } else if (name === 'emailChange') {
        return 'email-address-change'
      } else if (name === 'phoneChange') {
        return 'phone-change'
      }
    },
    fetchUserInfo () {
      this.$apiRequest.get('user/info')
        .then(response => {
          this.userInfo = response.data
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
    },
    handleRefresh (data) {
      if (data && data.type === 'userInfo') {
        this.fetchUserInfo()
      }
    }
  },
  created () {
    this.fetchUserInfo()
    addUserIdDataLayerEvent()
  },
  mounted () {
    if (lsGet('sc_changeEmailVerification')) {
      this.toast('success', {
        message: this.$t('toastMessages.successChangeEmailAddressMessage')
      })
      lsRemove('sc_changeEmailVerification')
    }
    this.$nextTick(() => {
      if (getHashPath() === 'platne-kartice') {
        setTimeout(() => {
          this.$refs.sidebarMenu.selectItem({ name: 'paymentCards' })
          clearHash()
        }, 10)
      }
    })

    addDataLayerEvent({
      event: 'screen',
      name: 'my_account'
    })
  }
}
</script>

<style scoped lang="scss">
.page-content {
  padding: 2rem 0;
}

.main-content {
  flex: 1 1 auto;
  padding: 0 2rem;
  max-width: 100%;
  width: 100%;

  @media (map_get($breakpoints, lg)) {
    padding-right: 0;
  }
}

.header-placeholder {
  min-height: 52px;
}
</style>
